import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import ProductHeader from "../components/productheader"
import ProductSection from "../components/productsection"
import Fundwall1 from "../images/fundwall_1.jpg"
import Fundwall2 from "../images/fundwall_2.jpg"
import Fundwall3 from "../images/fundwall_3.jpg"

const Fundwall = () => (
  <Layout>
    <SEO title="Nodano Fundwall" />
    <div className="relative max-w-screen-lg mx-auto">
      <ProductHeader title="Nodano Fundwall" subtitle="Front-end | Design" />
      <ProductSection image={Fundwall1} />
      <ProductSection image={Fundwall3} />
      <ProductSection image={Fundwall2} />
    </div>
  </Layout>
)

export default Fundwall
